'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('ballot-result', {
      url: '/voting/:voteId/ballot/result/:id',
      template: '<ballot-result></ballot-result>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/ballot-result/ballot-result.routes.js